module.exports = __webpack_public_path__ + "img/mine_blue.ad08c6f0.gif";